<template>
    <div class="footer-area-wrapper reveal-footer default-bg ">
      <div class="footer-copyright-area section-space--pt_60 section-space--pb_120">
          <div class="container">
                <div class="row aling-items-center">
                    <div class="col-md-12">
                        <div class="horizontal-list text-center">
                            <ul>
                                <li>
                                    <span class="copyright-text">
                                        &copy; 2023 <b>Dezinfekce potrubí.cz</b>
                                    </span>
                                </li>
                                <li>
                                    <a href="tel:603918213" class="hover-style-link hover-style-link--white">+420 603 918 213</a>
                                </li>
                                <li>
                                    <a href="mailto:dezinfekce@dezinfekcepotrubi.cz" class="hover-style-link hover-style-link--white">dezinfekce@dezinfekcepotrubi.cz</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "brandcoool",
}
</script>
